import React, {useState, useContext, useEffect} from 'react'; 
import UserContext  from '../../context/Globales/UserContext';
import {makeStyles, TableContainer, Table, TableCell, TableRow,TableHead,TableBody,Button, Grid, Modal,Fade,Backdrop, Typography} from '@material-ui/core';
import {v4 as uuid } from 'uuid';

import TblExtractoSociedad from './TblExtractoSociedad';
import TblDetalleSociedades from './TblDetalleSociedades';
import TblDetalleSocios from './TblDetalleSocios';
import IcpdfResumenSociedadSoc from '../pdf/IC/IcpdfResumenSociedadSoc';
    const useStyles = makeStyles((theme) => ({
        tituloTable: {
           backgroundColor: '#e6e6e6',
           minWidth: 200,
           color: 'black',
           textAlign: 'center',
           padding: '16px',
           fontWeight: '250',
           fontSize : '16px'
        },
        TituloIdentificacion: {
           backgroundColor: theme.palette.primary.main,
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '15px',
           fontWeight: '250',
           fontSize : '18px',
           height: 'auto',
           alignContent: 'center',
        },
        modaldetalle: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          overflow:'scroll',
           height:'100%',
        },
      paperdetalle: {
          backgroundColor: theme.palette.background.paper,
          border: '2px solid #000',
          boxShadow: theme.shadows[5],
          padding: theme.spacing(2, 4, 3),
          width: '90%',
          height: '90%',
          overflow:'scroll',
        },

        modalExtracto: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            overflow:'scroll',
             height:'100%',
          },
        paperExtracto: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: '50%',
            height: '50%',
            overflow:'scroll',
          },

          modalPdf: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          },
          paperPdf: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: '50%',
          },
        FondoTable :{
       
            backgroundColor: theme.palette.greyFondo.main
        },



        containerTable: {
            maxHeight: 440,
            maxWidth: '100%'
          },
          mousePointer : {cursor: 'pointer'},
    }));

const TblSociedades = () => {
    const userContext = useContext(UserContext);
    const { DatoListaSA, DvValidado, RutValidado } = useContext(UserContext);
    const classes = useStyles();
    const [datodetalleSociedad, setdatodetalleSociedad] = React.useState();
    const [datodetalleSocios, setdetalleSocios] = React.useState();
    const [OpenModalDetalleSociedad, setOpenModalDetalleSociedad] = React.useState(false);
    const [OpenModalDetalleSocios, setOpenModalDetalleSocios] = React.useState(false);
    const [OpenModalpdfResumen, setOpenModalpdfResumen] = React.useState(false);


    const handlClicOpenModalpdfresumen =()=>{
      setOpenModalpdfResumen(!OpenModalpdfResumen);
    }

    const handleClickDetalleSociedades =()=>{
      setOpenModalDetalleSociedad(!OpenModalDetalleSociedad);
    };

    const handleClickDetalleSocio = ()=>{
        setOpenModalDetalleSocios(!OpenModalDetalleSocios);
    }
    const DetalleSociedad=(BusquedadSociedad) => {
     // console.log(BusquedadSociedad);

      const resultadoSociedades = DatoListaSA.DetalleSociedades.find( dato => dato.Extracto === BusquedadSociedad );

      // asigno los datos obtenido al estado
      setdatodetalleSociedad(resultadoSociedades);

      //Levanto el modal del detalle socios;
      handleClickDetalleSociedades();

      //EJECUTO EL EL LLAMADO PARA ASIGNAR NULL  DATA EXTRACTO;
      userContext.getNullDataExtracto();
    };

    const DetalleSocios = (BusquedaSocios) => {

      const resultadoSocios = DatoListaSA.DetalleSocios.find(datosocio =>datosocio.Extracto ===BusquedaSocios);
        // asigno los datos obtenido al estado
        setdetalleSocios(resultadoSocios);

      //Levanto el modal del detalle socios;
      handleClickDetalleSocio();
      //EJECUTO EL EL LLAMADO PARA ASIGNAR NULL  DATA EXTRACTO
      userContext.getNullDataExtracto();

    }


    return (
        <>


          {/*MODAL PDF INFORME COMER*/}

          <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalpdfResumen}
                onClose={handlClicOpenModalpdfresumen}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalpdfResumen}>

                    <div className={classes.paperPdf}>


                        <IcpdfResumenSociedadSoc />



                    </div>

                </Fade>
            </Modal>


            {/*detalle de sociedad*/}
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modaldetalle}
                open={OpenModalDetalleSociedad}
                onClose={handleClickDetalleSociedades}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={OpenModalDetalleSociedad}>
                  <div className={classes.paperdetalle}>
                  <Typography variant="h5" align="right"  onClick={handleClickDetalleSociedades} className={classes.mousePointer} >X</Typography>

                    <TblDetalleSociedades dataSociedades={datodetalleSociedad}  />

                  </div>
                </Fade>
              </Modal>

              {/*detalle de Socios*/}
              <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modaldetalle}
                open={OpenModalDetalleSocios}
                onClose={handleClickDetalleSocio}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={OpenModalDetalleSocios}>
                  <div className={classes.paperdetalle}>


                  <Typography variant="h5" align="right"  onClick={handleClickDetalleSocio} className={classes.mousePointer} >X</Typography>
                    <TblDetalleSocios dataSocios={datodetalleSocios}  />

                  </div>
                </Fade>
              </Modal>


   <h5>{DatoListaSA ==='ERROR CONSULTA ASOCIADOS' ?
                'Error al procesar su solicitud, inténtelo mas tarde (INFORME COMERCIAL)' : ''}</h5>

          <h6 className={classes.tituloTable}>Socios y Sociedades</h6>


          <br />
            {DatoListaSA && DatoListaSA.Resumen!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={handlClicOpenModalpdfresumen}>Descargar PDF</Button></div> : ''}
            <br />

            {DatoListaSA && DatoListaSA.Resumen==null  ? <h2>Cargando información...</h2> :
            

        


             <Grid  container direction="row"  justify="space-between" alignItems="flex-start">
             <Grid item={true} xs={12} sm={12} xl={6} md={6} lg={6}>
             <TableContainer className={classes.containerTable}>
                <Table>
                    <TableHead className={classes.FondoTable}>
                        <TableRow>

                            <TableCell>N°. de Publicaciones:</TableCell>
                            <TableCell>N°. Sociedades:</TableCell>
                            <TableCell>N°. de Socios:</TableCell>
                            
                        </TableRow>
                        </TableHead>
                        <TableBody>

                        <TableRow key={uuid()+1}>
                        <TableCell>{DatoListaSA && DatoListaSA.Resumen?.NumeroPublicaciones}</TableCell>
                            <TableCell>{DatoListaSA && DatoListaSA.Resumen?.ComoSociedades}</TableCell>
                            <TableCell>{ DatoListaSA && DatoListaSA.Resumen?.ComoSocio}</TableCell>
                        </TableRow>

                        </TableBody>
                    
            
                </Table>
             </TableContainer>
             </Grid>




             </Grid>
             }

              <Grid  container direction="row"  justify="space-between" alignItems="flex-start">

              <Grid item={true} xs={12} sm={12} xl={12} md={12} lg={12}>
              {DatoListaSA && DatoListaSA.DetalleSociedades !=null ?  
             
             <TableContainer className={classes.containerTable}>
               <h6 className={classes.tituloTable}>Detalle de Sociedades</h6>
             <Table size="small">
             <TableHead className={classes.FondoTable}>
                 <TableRow>
                     <TableCell>#</TableCell>
                     <TableCell>Nombre</TableCell>
                     <TableCell>Constituidad como</TableCell>
                     <TableCell>Fecha Escritura</TableCell>
                     <TableCell>----</TableCell>
                 
                 </TableRow>
             </TableHead>
             <TableBody>
              { DatoListaSA && DatoListaSA.DetalleSociedades?.map((resSocied, idSocied)=>(
               <TableRow key={idSocied}>
               <TableCell>{idSocied+1}</TableCell>
               <TableCell>{resSocied.Detalles[0].NombreRazonSocial}   </TableCell>
               <TableCell>{resSocied.Detalles[0].ConstituidaComo}</TableCell>
               <TableCell>{resSocied.Detalles[0].FechaEscritura}</TableCell>
               <TableCell><Button variant="outlined" color="primary" onClick={()=>{ DetalleSociedad(resSocied.Extracto)}}>Ver detalle</Button></TableCell>
              </TableRow>
              ))}
               </TableBody>
 
             </Table>
     
         </TableContainer>
                : ''}
          </Grid>
          <Grid item={true} xs={12} sm={12} xl={12} md={12} lg={12}>        

            {DatoListaSA && DatoListaSA.DetalleSocios!=null ?  
             
             <TableContainer className={classes.containerTable}>
               <h6 className={classes.tituloTable}>Detalle de Socios</h6>
             <Table size="small">
             <TableHead className={classes.FondoTable}>
                 <TableRow>
                   <TableCell>#</TableCell>
                     <TableCell>Nombre</TableCell>
                     <TableCell>Constituidad como</TableCell>
                     <TableCell>Fecha Escritura</TableCell>
                     <TableCell>----</TableCell>
                 
                 </TableRow>
             </TableHead>
             <TableBody>
              {DatoListaSA && DatoListaSA.DetalleSocios?.map((resSocio, idSocios)=>(
               <TableRow key={idSocios}>
                 <TableCell>{idSocios+1}</TableCell>
               <TableCell>{resSocio.Detalles[0].NombreRazonSocial}   </TableCell>
               <TableCell>{resSocio.Detalles[0].ConstituidaComo}</TableCell>
               <TableCell>{resSocio.Detalles[0].FechaEscritura}</TableCell>
               <TableCell><Button variant="outlined" color="primary" onClick={()=>{DetalleSocios(resSocio.Extracto) }}>Ver Detalle</Button></TableCell>
              </TableRow>
              ))}
               </TableBody>
 
             </Table>
     
         </TableContainer>
                : ''}

            </Grid>

      </Grid>
              
            

        
        </>
    )
}

export default TblSociedades;
